if (!customElements.get('price-range')) {
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.minNumberInput = document.getElementById('price-range-number-min');
      this.maxNumberInput = document.getElementById('price-range-number-max');
      this.minSliderInput = document.getElementById('price-range-slider-min');
      this.maxSliderInput = document.getElementById('price-range-slider-max');
      this.minValue = Number(this.minNumberInput.min);
      this.maxValue = Number(this.maxNumberInput.max);
      this.timeout = null;
      this.addEventListener('input', this.handleInput.bind(this));
    }

    /**
     * Handles 'input' events on the price range component.
     * @param {object} evt - Event object.
     */
    handleInput(evt) {
      if (evt.target.type === 'number') {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.updateSliderInputs(evt);
          this.updateNumberInputs();
        }, 500);
      } else {
        this.updateSliderInputs(evt);
        this.updateNumberInputs();
      }
    }

    /**
     * Updates the value of the 'number' type inputs.
     */
    updateNumberInputs() {
      this.minNumberInput.value = this.minSliderInput.value !== this.minNumberInput.min
        ? this.minSliderInput.value : null;

      this.maxNumberInput.value = this.maxSliderInput.value !== this.maxNumberInput.max
        ? this.maxSliderInput.value : null;
    }

    /**
     * Updates the value of the 'range' type inputs.
     * @param {object} evt - Event object.
     */
    updateSliderInputs(evt) {
      const targetIsMin = evt.target === this.minNumberInput
        || evt.target === this.minSliderInput;
      const targetIsMax = evt.target === this.maxNumberInput
        || evt.target === this.maxSliderInput;
      const enteredMin = evt.target === this.minSliderInput
        ? Number(this.minSliderInput.value) : Number(this.minNumberInput.value);
      const enteredMax = evt.target === this.maxSliderInput
        ? Number(this.maxSliderInput.value) : Number(this.maxNumberInput.value);
      let minValue = evt.target === this.minSliderInput || this.minNumberInput.value !== ''
        ? enteredMin : this.minValue;
      let maxValue = evt.target === this.maxSliderInput || this.maxNumberInput.value !== ''
        ? enteredMax : this.maxValue;

      minValue = Math.min(Math.max(minValue, this.minValue), this.maxValue);
      maxValue = Math.min(Math.max(maxValue, this.minValue), this.maxValue);

      if (minValue > maxValue) {
        if (targetIsMin) {
          minValue = maxValue;
        } else if (targetIsMax) {
          maxValue = minValue;
        }
      }

      this.minSliderInput.value = minValue;
      this.maxSliderInput.value = maxValue;
    }
  }

  customElements.define('price-range', PriceRange);
}
